import type { SelfConversationsResponseDatagramBuf } from "~/classes/generated/response"

import { DatagramBuf } from "~/classes/generated/datagram"
import { RequestDatagramBuf, SelfConversationsRequestDatagramBuf } from "~/classes/generated/request"
import { DatagramBufferBuilder } from "~/utils/flatbuffers/builder"
import { parseConversation } from "~/utils/flatbuffers/conversation"
import { addRequestIdToBuf, parseDatagramError, parseRequestId, parseVector } from "~/utils/flatbuffers/datagram"
import { addEntityPropertySelectionToBuf } from "~/utils/flatbuffers/entity"
import { maybe } from "~/utils/helpers"

const console = useLogger("user/info", theme.colors.pink.hex)

export function sendSelfConversationsRequest(request: SelfConversationsRequestDatagram) {
  const { sendWorkerDatagramBuf } = useCache()

  const fbb = new DatagramBufferBuilder(64)

  const selection = addEntityPropertySelectionToBuf(fbb, request.selection)
  const requestId = addRequestIdToBuf(fbb, request.requestId)
  SelfConversationsRequestDatagramBuf.startSelfConversationsRequestDatagramBuf(fbb)
  SelfConversationsRequestDatagramBuf.addRequestId(fbb, requestId)
  SelfConversationsRequestDatagramBuf.addOffline(fbb, request.offline)
  SelfConversationsRequestDatagramBuf.addSelection(fbb, selection)
  const convoRequest = SelfConversationsRequestDatagramBuf.endSelfConversationsRequestDatagramBuf(fbb)

  RequestDatagramBuf.startRequestDatagramBuf(fbb)
  RequestDatagramBuf.addSelfConversationsRequest(fbb, convoRequest)
  const requests = DatagramBuf.createRequestVector(fbb, [RequestDatagramBuf.endRequestDatagramBuf(fbb)])
  DatagramBuf.startDatagramBuf(fbb)
  DatagramBuf.addRequest(fbb, requests)
  fbb.finish(DatagramBuf.endDatagramBuf(fbb))
  sendWorkerDatagramBuf(fbb.asUint8Array())
}

export function handleSelfConversationsResponseDatagramBuf(datagram: SelfConversationsResponseDatagramBuf) {
  try {
    onSelfConversationsResponseDatagram({
      requestId: parseRequestId(datagram.requestId()!),
      offline: datagram.offline(),
      error: maybe(parseDatagramError)(datagram.error()),
      conversations: parseVector(n => parseConversation(datagram.conversations(n)!), datagram.conversationsLength()),
    })
  }
  catch (error) {
    console.error("Failed to handle self conversations response datagram", error)
  }
}

export function onSelfConversationsResponseDatagram(response: SelfConversationsResponseDatagram) {
  const { emitInterfaceEvent, emitEntityEvent } = useEvents()

  emitInterfaceEvent("selfConversationsResponse", response, response.requestId)

  if (response.error || response.conversations === undefined)
    return console.error("Conversations info request failed", response)

  for (const conversation of response.conversations)
    emitEntityEvent("conversationProperties", conversation.id, conversation, response.offline)
}
